<div class="home-block light">
  <div class="home-container d-flex-decor">
    <div>
      <div
        *appFadeInOnScroll
        class="fadeInit fadeInLeft decor-rectangle movementInit movement"
        id="location-decor"
      >
        <p>HELYSZÍN</p>
        <hr />
      </div>
    </div>
    <div *appFadeInOnScroll class="fadeInit fadeInRight" id="location-text">
      <p>
        <b>SZEGED, {{ eventInfo['dateText'] }}</b>
      </p>
      <p>Helyszín: {{ eventInfo['location'] }}</p>
      <p>Műsorvezető, ceremóniamester: {{ eventInfo['masterOfCeremonies'] }}</p>
      <p>A kiállítás kezdődik (kapunyitás): {{ eventInfo['gateOpening'] }}</p>
      <p> A rendezvény {{ eventInfo['openingHours'] }} ingyenesen látogatható. </p>
    </div>
  </div>
</div>
